import React from 'react';

import { CarrierFactory } from '../../../../../../common/carrierConfig/carrierFactory';
import { Carriers } from '../../../../../../common/constants/carriers';
import { DrawerLetterBody } from '../../drawer/DrawerLetterBody';
import { LetterFormData } from '../hooks/useLetterForm';
import { LetterTypes, Sources } from '../types';

export interface OtafSamePriceLetterContentProps {
  source: Sources;
  formData: LetterFormData;
  carrier: Carriers;
  riders: string[];
}

const OtafSamePriceLetterContent = ({
  source,
  formData,
  carrier,
  riders,
}: OtafSamePriceLetterContentProps) => (
  <DrawerLetterBody
    letterType={LetterTypes.otafSamePrice}
    pricingMode="same"
    isJuvenile={false}
    carrier={carrier}
    carrierDisplayName={
      CarrierFactory.getCarrierConfig(carrier)?.getCarrierDisplayName() ?? ''
    }
    riders={riders}
    selectedRiders={riders}
    selectedSources={[source]}
    fieldValues={formData as Record<string, string>}
    hasFcra={false}
  />
);

export default OtafSamePriceLetterContent;
